export const L10N = {
  ACTION_ACCEPT: { id: 'common.action.accept' },
  ACTION_REJECT: { id: 'common.action.reject' },
  ACTION_REJECT_ALL: { id: 'core.action.reject_all' },
  ACTION_SAVE: { id: 'common.action.save' },
  ACTION_SETTINGS: { id: 'common.action.settings' },

  LABEL_ALWAYS_ACTIVE: { id: 'core.label.always_active' },
  LABEL_ANALYTICAL_COOKIES_CONTENT: { id: 'core.label.analytical_cookies_content' },
  LABEL_ANALYTICAL_COOKIES_TITLE: { id: 'core.label.analytical_cookies_title' },
  LABEL_COOKIES_CONTENT: { id: 'core.label.cookies_content' },
  LABEL_COOKIES_MORE_INFO: { id: 'core.label.cookies_more_info' },
  LABEL_COOKIES_PREFERENCES: { id: 'core.label.cookies_preferences' },
  LABEL_COOKIES_SETTINGS: { id: 'core.label.cookies_settings' },
  LABEL_COOKIES_SETTINGS_CONTENT: { id: 'core.label.cookies_settings_content' },
  LABEL_COOKIES_SETTINGS_INFO: { id: 'core.label.cookies_settings_info' },
  LABEL_COOKIES_SETTINGS_PRIVACY: { id: 'core.label.cookies_settings_privacy' },
  LABEL_CUSTOMIZE_CHOICES: { id: 'core.label.customize_choices' },
  LABEL_HERE: { id: 'core.label.here' },
  LABEL_MANDATORY_COOKIES_CONTENT: { id: 'core.label.mandatory_cookies_content' },
  LABEL_MANDATORY_COOKIES_TITLE: { id: 'core.label.mandatory_cookies_title' },
};
